export default __webpack_public_path__ + "static/media/RHB.e713e6a6.png";